import { render } from "./SummaryBox2.vue?vue&type=template&id=3ca3d584&scoped=true"
import script from "./SummaryBox2.vue?vue&type=script&lang=js"
export * from "./SummaryBox2.vue?vue&type=script&lang=js"

import "./SummaryBox2.vue?vue&type=style&index=0&id=3ca3d584&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca3d584"]])

export default __exports__